import React from 'react';
import NotificationFormWidget from '../../../../form/widgets/NotificationFormWidget';
import { useInternalShareSettings } from '../../hooks/useInternalShareSettings';

export interface ShareNotificationFormFieldProps {
    hideNotifyContactsSelection?: boolean;
    allowAddingNotifyContactsOptions?: boolean;
}

export default function ShareNotificationFormField({
    hideNotifyContactsSelection = false,
    allowAddingNotifyContactsOptions = false
}: ShareNotificationFormFieldProps) {
    const { shareSettings, updateShareSettingsState, enableNotification } = useInternalShareSettings();

    if (!enableNotification) {
        return null;
    }

    return (
        <NotificationFormWidget
            value={{
                notify: shareSettings.notify,
                customMessage: shareSettings.customMessage,
                notifyContacts: shareSettings.notifyContacts
            }}
            onChange={updateShareSettingsState}
            hideNotifyContactsSelection={hideNotifyContactsSelection}
            allowAddingNotifyContactsOptions={allowAddingNotifyContactsOptions}
            editorId="share-settings-custom-message"
        />
    );
}
